import React, { useState } from "react";
import "./Franchise.css";
import { API_BASE_URL } from "../config";

export default function Franchise() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    investment: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Submitting...");

    try {
      const res = await fetch(`${API_BASE_URL}/api/franchise/apply`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      if (res.ok) {
        setStatus("✅ Franchise request submitted successfully! Check your email for confirmation.");
        setForm({
          name: "",
          email: "",
          phone: "",
          city: "",
          investment: "",
          message: "",
        });
      } else {
        setStatus("❌ Submission failed. Try again.");
      }
    } catch (err) {
      setStatus("⚠ Server error. Please try later.");
    }
  };

  return (
    <div className="franchise-page">
      {/* 1. HERO SECTION */}
      <section className="franchise-hero">
        <div className="hero-content">
          <h1>Flytutor Franchise Opportunity</h1>
          <p>Partner with India’s leading DGCA-approved drone training academy and build a future-ready business in the rapidly evolving UAV industry.</p>
        </div>
      </section>

      {/* 2. STATS & OPPORTUNITIES HIGHLIGHTS */}
      <section className="franchise-highlights-section">
        <div className="highlights-grid">
          <div className="highlight-card">
            <div className="h-icon">🌐</div>
            <h3>Global Opportunities</h3>
            <p>Expand your reach with our globally recognized training certifications and standardized curricula.</p>
          </div>
          <div className="highlight-card">
            <div className="h-icon">📈</div>
            <h3>Proven Statistics</h3>
            <p>Join a network with a 95% student placement rate and consistent year-over-year revenue growth.</p>
          </div>
          <div className="highlight-card special-offer">
            <h3>Special Offer</h3>
            <p>Kickstart your journey today with exclusive early-bird benefits for our next 5 franchise partners.</p>
            <button className="cta-sm-btn" onClick={() => document.getElementById('apply-form').scrollIntoView({ behavior: 'smooth' })}>Apply Now</button>
          </div>
        </div>
      </section>

      {/* 3. ADVANTAGES SECTION */}
      <section className="franchise-advantages-section">
        <div className="section-container">
          <h2 className="section-title">Our Competitive Advantages</h2>
          <div className="advantages-layout">
            <div className="advantage-visual">
              <div className="vector-placeholder">
                <svg viewBox="0 0 200 200" className="vector-svg minimalist-drone">
                  {/* Frosted Background Circle */}
                  <circle cx="100" cy="100" r="90" fill="rgba(88, 23, 158, 0.03)" />
                  
                  {/* Minimalist Hexagon Frame */}
                  <path d="M100 30 L160 65 L160 135 L100 170 L40 135 L40 65 Z" fill="none" stroke="#58179e" strokeWidth="4" strokeLinejoin="round" />
                  
                  {/* Ultra-Minimal Drone Silhouette */}
                  <g className="drone-core">
                    <circle cx="100" cy="100" r="12" fill="#58179e" />
                    <line x1="100" y1="100" x2="135" y2="135" stroke="#58179e" strokeWidth="6" strokeLinecap="round" />
                    <line x1="100" y1="100" x2="65" y2="65" stroke="#58179e" strokeWidth="6" strokeLinecap="round" />
                    <line x1="100" y1="100" x2="135" y2="65" stroke="#58179e" strokeWidth="6" strokeLinecap="round" />
                    <line x1="100" y1="100" x2="65" y2="135" stroke="#58179e" strokeWidth="6" strokeLinecap="round" />
                  </g>
                </svg>
              </div>
            </div>


            <div className="advantage-details">
              <div className="adv-item">
                <span className="adv-number">01</span>
                <div>
                  <h4>DGCA Authorized RPTO</h4>
                  <p>Operate under a fully compliant and authorized Remote Pilot Training Organization framework.</p>
                </div>
              </div>
              <div className="adv-item">
                <span className="adv-number">02</span>
                <div>
                  <h4>Turnkey Training Model</h4>
                  <p>Get everything from site selection to instructor training handled by our expert team.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. BEST FEATURES SECTION */}
      <section className="franchise-features-section">
        <div className="section-container">
          <h2 className="section-title">Why Partners Love Us</h2>
          <div className="features-circle-grid">
            <div className="f-circle-item">
              <div className="vector-icon-wrap">
                <svg viewBox="0 0 24 24" fill="none" stroke="#58179e" strokeWidth="1.5">
                  <path d="M12 21a9 9 0 100-18 9 9 0 000 18z" />
                  <path d="M3.6 9h16.8M3.6 15h16.8" />
                  <path d="M12 3a15.3 15.3 0 010 18 15.3 15.3 0 010-18z" />
                </svg>
              </div>
              <h4>Global Content</h4>
              <p>Standardized high-quality educational material used worldwide.</p>
            </div>
            <div className="f-circle-item">
              <div className="vector-icon-wrap">
                <svg viewBox="0 0 24 24" fill="none" stroke="#58179e" strokeWidth="1.5">
                  <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
                </svg>
              </div>
              <h4>Expert Support</h4>
              <p>24/7 technical and administrative assistance for your academy.</p>
            </div>
            <div className="f-circle-item">
              <div className="vector-icon-wrap">
                <svg viewBox="0 0 24 24" fill="none" stroke="#58179e" strokeWidth="1.5">
                  <path d="M3 3h18v18H3z" />
                  <path d="M3 9h18M9 21V9" />
                </svg>
              </div>
              <h4>Scalable Model</h4>
              <p>A business model designed to grow with market demand.</p>
            </div>
          </div>
        </div>
      </section>


      {/* 5. MANAGEMENT & STATISTICS SECTION */}
      <section className="franchise-management-section">
        <div className="management-layout">
          <div className="mgmt-text">
            <h3>Management Statistics</h3>
            <p>Our sophisticated management system allows you to track every student's progress and financial health in real-time.</p>
            <ul className="mgmt-list">
              <li>Real-time Lead Tracking</li>
              <li>Automated Certification Flow</li>
              <li>Consolidated Financial Dashboards</li>
            </ul>
          </div>
          <div className="mgmt-visual">
             <div className="bar-chart-mock">
                <div className="bar" style={{height: '60%'}}><span>A</span></div>
                <div className="bar" style={{height: '80%'}}><span>B</span></div>
                <div className="bar" style={{height: '45%'}}><span>C</span></div>
                <div className="bar" style={{height: '95%'}}><span>D</span></div>
                <div className="bar" style={{height: '70%'}}><span>E</span></div>
                <div className="bar" style={{height: '30%'}}><span>F</span></div>
             </div>
          </div>
        </div>
      </section>

      {/* 6. FORM / CTA SECTION */}
      <section className="franchise-form-section" id="apply-form">
        <div className="section-header">
           <h2 className="flytutor-main-heading">Ready to Take the Next Step?</h2>
           <p>Fill out the form below and our franchise development team will get in touch with you within 24 hours.</p>
        </div>

        <form className="franchise-form" onSubmit={handleSubmit}>
          <div className="form-grid">
            <input name="name" placeholder="Full Name" value={form.name} onChange={handleChange} required />
            <input name="email" type="email" placeholder="Email Address" value={form.email} onChange={handleChange} required />
            <input name="phone" placeholder="Phone Number" value={form.phone} onChange={handleChange} required />
            <input name="city" placeholder="City / Location" value={form.city} onChange={handleChange} required />
          </div>

          <select name="investment" value={form.investment} onChange={handleChange} required >
            <option value="">Select Investment Range</option>
            <option value="10-20 Lakhs">10 – 20 Lakhs</option>
            <option value="20-30 Lakhs">20 – 30 Lakhs</option>
            <option value="30+ Lakhs">30+ Lakhs</option>
          </select>

          <textarea name="message" placeholder="Tell us more about your background and interest..." value={form.message} onChange={handleChange} />

          <button type="submit">Submit Application</button>
        </form>

        {status && <p className="form-status">{status}</p>}
      </section>
    </div>
  );
}

